var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElectrolytes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.3789 102.539V206.055H161.621V102.539H88.3789ZM146.973 191.406H103.027V176.758H146.973V191.406ZM146.973 146.484H132.324V161.133H117.676V146.484H103.027V131.836H117.676V117.188H132.324V131.836H146.973V146.484Z",
    fill: "#6C6969",
    fillOpacity: 0.52
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176.27 46.7415V21.9727C176.27 9.85718 166.412 0 154.297 0C142.181 0 132.324 9.85718 132.324 21.9727V43.9453H117.676V21.9727C117.676 9.85718 107.819 0 95.7031 0C83.5876 0 73.7305 9.85718 73.7305 21.9727V46.7415L44.4336 61.3899V131.836H73.7305V87.8906H176.27V130.859H205.566V61.3899L176.27 46.7415Z",
    fill: "#6C6969",
    fillOpacity: 0.52
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M176.27 220.703H73.7305V146.484H44.4336V213.379C44.4336 233.57 60.8635 250 81.0547 250H168.945C189.137 250 205.566 233.57 205.566 213.379V145.508H176.27V220.703Z",
    fill: "#6C6969",
    fillOpacity: 0.52
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectrolytes);
export default __webpack_public_path__ + "static/media/Electrolytes.88f62d8b97f9fe4dd731d14af9328b75.svg";
export { ForwardRef as ReactComponent };